import { h } from "preact";
import { useState } from "preact/hooks";
import style from "./App.css";
import calcImg from "../assets/calculator.png";
import handClickImg from "../assets/hand_click.svg";
import { products, dimensions } from "./data";

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries()) || {};
const url = params.url || null;

const App = () => {
  const [product, setProduct] = useState();
  const [join, setJoin] = useState();
  const [dimType, setDimType] = useState();
  const [dimTarget, setDimTarget] = useState("");
  const [dim, setDim] = useState(null);
  const [qtyMc, setQtyMc] = useState("");
  const [qtyMp, setQtyMp] = useState("");
  const [qtyCm, setQtyCm] = useState("");
  const [showCalculate, setShowCalculate] = useState(false);

  const handleChangeProduct = (pid) => () => {
    setProduct(pid);
    setJoin();
    setDimType();
    setDimTarget("");
    setDim(null);
    setQtyMc("");
    setQtyMp("");
    setQtyCm("");
    setShowCalculate(false);
  };

  const handleChangeJoin = (type) => () => {
    setJoin(type);
    if (product === "p2") {
      setDimType("BCA");
    }
    setShowCalculate(false);
  };

  const handleDimType = (type) => () => {
    setDimType(type);
    setDimTarget("");
    setDim(null);
    setShowCalculate(false);
  };

  const handleDimChange = (e) => {
    const dim = e.target.value;
    if (dim !== "other") {
      const [x, y, z] = dim.split("x").map((d) => parseInt(d.trim(), 10));
      setDim({ x, y, z });
    } else {
      setDim(null);
    }
    setDimTarget(e.target.value);
    setShowCalculate(false);
    setQtyMp("");
    setQtyMc("");
    scrollBottom();
  };

  const handleDimValuesChange = (type) => (e) => {
    const { value } = e.target;
    setDim({ ...dim, [type]: value ? parseFloat(value) : "" });
    setShowCalculate(false);
    setQtyMp("");
    setQtyMc("");
  };

  const handleDimSet = () => {
    scrollBottom();
  };

  const handleChangeQty = (type) => (e) => {
    const { value } = e.target;
    if (type === "MC") {
      setQtyMc(parseFloat(value));
      setQtyMp("");
    }
    if (type === "MP") {
      setQtyMp(parseFloat(value));
      setQtyMc("");
    }
    if (type === "CM") {
      setQtyCm(parseFloat(value));
    }
  };

  const handleCalculate = () => {
    if (!qtyMc && !qtyMp && !qtyCm) return;

    let results = { kg: "N/A", bags: "N/A" };
    if (product === "p1" || product === "p2") {
      if (!dim) return;
      const { x, y, z } = dim;
      let qtyType = "mc";
      let qty = qtyMc;
      if (qtyMp) {
        qtyType = "mp";
        qty = qtyMp;
      }
      results = calculateTotal({ p: product, qty, join, qtyType, x, y, z });
    } else {
      results = calculateTotal({ p: product, qty: qtyCm });
    }
    setShowCalculate(results);
    scrollBottom();
  };

  const renderProducts = () => (
    <div class={style.animated}>
      <div class={style.title}>
        <div class="color-blue">Alege tipul de mortar</div>
      </div>
      <div class={style.products_container}>
        {products.map((p) => (
          <div key={p.id}>
            <div class={style.product_title}>TectorPlast</div>
            <div
              class={`${style.product} ${
                product === p.id && style.product_selected
              }`}
              onClick={handleChangeProduct(p.id)}
            >
              <img src={p.img} />
              <div class={style.product_name}>{p.name}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderJoins = () => (
    <div class={`${style.joins_wrap} ${style.animated}`}>
      <div class={style.title}>
        <div class="color-white">Selectează tip îmbinare</div>
      </div>
      <div class={style.joins_container}>
        <div
          class={`${style.button} ${join === 2 && style.button_active}`}
          onClick={handleChangeJoin(2)}
        >
          Cu Nut și Feder
        </div>
        <div
          class={`${style.button} ${join === 1 && style.button_active}`}
          onClick={handleChangeJoin(1)}
        >
          Fără Nut și Feder
        </div>
      </div>
    </div>
  );

  const renderDimensions = () => (
    <div class={style.animated}>
      <div class={style.title}>
        <div class="color-blue">
          Selecteaza dimensiunile elementelor de zidărie
        </div>
      </div>
      {product === "p1" && (
        <div class={style.dim_container}>
          <div
            class={`${style.button} ${
              dimType === "CARAMIDA" && style.button_active
            }`}
            onClick={handleDimType("CARAMIDA")}
          >
            Pentru CĂRĂMIDĂ
          </div>
          <div
            class={`${style.button} ${
              dimType === "BOLTAR" && style.button_active
            }`}
            onClick={handleDimType("BOLTAR")}
          >
            Pentru BOLȚAR
          </div>
          <div
            class={`${style.button} ${
              dimType === "BCA" && style.button_active
            }`}
            onClick={handleDimType("BCA")}
          >
            Pentru BCA
          </div>
        </div>
      )}
      {dimType && (
        <>
          <select
            aria-label="Dimensiuni"
            class={style.dd}
            value={dimTarget}
            onChange={handleDimChange}
          >
            <option value="" selected>
              Selectează dimensiune
            </option>
            {dimensions[dimType].map((d) => (
              <option value={d} key={d}>
                {d}
              </option>
            ))}
            <option value="other" key="other">
              Alte dimensiuni
            </option>
          </select>
        </>
      )}
      {dimTarget === "other" && (
        <div class={style.qnty_container}>
          <input
            name="x"
            placeholder="Lungime"
            type="number"
            min="0"
            value={dim?.x}
            onChange={handleDimValuesChange("x")}
          />
          <span>x</span>
          <input
            name="y"
            placeholder="Latime"
            type="number"
            min="0"
            value={dim?.y}
            onChange={handleDimValuesChange("y")}
          />
          <span>x</span>
          <input
            name="z"
            placeholder="Inaltime"
            type="number"
            min="0"
            value={dim?.z}
            onChange={handleDimValuesChange("z")}
          />
          <div
            class={`${style.button} ${style.button_active}`}
            style={{ display: "inline-block" }}
            onClick={handleDimSet}
          >
            Setează
          </div>
        </div>
      )}
      {dimType && (
        <div class={style.disclaimer}>
          {product === "p1" && <div>* Grosimea rostului este de 1 cm</div>}
          {product === "p2" && <div>* Grosimea rostului este de 0,3 cm</div>}
        </div>
      )}
    </div>
  );

  const renderQnty = () => (
    <div class={`${style.qnty_wrap} ${style.animated}`}>
      <div class={style.title}>
        <div class="color-white">Suprafața de zidit</div>
      </div>
      <div class={style.qnty_container}>
        <input
          name="qtyMc"
          // placeholder="m³"
          type="number"
          min="0"
          value={qtyMc}
          onChange={handleChangeQty("MC")}
        />
        <label>m³</label>
        <span>sau</span>
        <input
          name="qtyMp"
          // placeholder="m²"
          type="number"
          min="0"
          value={qtyMp}
          onChange={handleChangeQty("MP")}
        />
        <label>m²</label>
        <div
          class={`${style.button} ${style.button_active}`}
          style={{ display: "inline-block" }}
          onClick={handleCalculate}
        >
          Calculează
        </div>
      </div>
    </div>
  );

  const renderQntyP3 = () => (
    <div class={`${style.qnty_wrap} ${style.animated}`}>
      <div class={style.title}>
        <div class="color-white">Suprafața de tencuit</div>
      </div>
      <div class={style.qnty_container}>
        <input
          id="qtyMp"
          name="qtyMp"
          // placeholder="m²"
          type="number"
          min="0"
          value={qtyCm}
          onChange={handleChangeQty("CM")}
        />
        <label>m²</label>
        <div
          class={`${style.button} ${style.button_active}`}
          style={{ display: "inline-block" }}
          onClick={handleCalculate}
        >
          Calculează
        </div>
      </div>
      <div class={style.disclaimer}>
        <div>* Grosimea stratului este de 1 cm</div>
      </div>
    </div>
  );

  const renderCalculate = () => (
    <>
      <div class={`${style.calc_container} ${style.animated}`}>
        <table class={style.calc_table}>
          <tr>
            <td
              class={style.calc_table_t}
              rowspan="2"
              style="text-align: center"
            >
              <img src={calcImg} />
              Necesar
            </td>
            <td class={style.calc_table_v}>{Math.ceil(showCalculate.kg)} KG</td>
          </tr>
          <tr>
            <td class={style.calc_table_v}>
              {Math.ceil(showCalculate.bags)} Saci
            </td>
          </tr>
        </table>
      </div>
      <div
        class={`${style.qnty_wrap} ${style.animated}`}
        style={{ marginBottom: 20 }}
      >
        Pune Tector la treabă!&nbsp;
        <img src={handClickImg} width="35" />
        <a
          href={url ? url : "https://tector.holcim.ro/vreau-oferta"}
          target="_parent"
          rel="noreferrer"
          class={style.offer_link}
        >
          {url ? "Comandă online" : "Cere ofertă aici!"}
        </a>
      </div>
      <div class={style.disclaimer}>
        * Utilizează acest calculator pentru a estima necesarul de material.
        Rezultatele sunt orientative și pot să difere în funcție de proiectul
        tău.
      </div>
    </>
  );

  return (
    <div class={style.container}>
      <div class={`${style.joins_wrap} ${style.animated}`}>
        <div class={style.title_text}>
          <div class="color-white">
            Folosește gratuit calculatorul de materiale să știi exact cât ai
            nevoie pentru lucrarea ta. <br />
            Este simplu și eficient de folosit, la fel ca mortarele Tector.
          </div>
        </div>
      </div>
      <div>{renderProducts()}</div>
      {product !== "p3" && (
        <>
          <div>{product && renderJoins()}</div>
          <div>{join && renderDimensions()}</div>
          <div>{dim && dim.x && dim.y && dim.z && renderQnty()}</div>
        </>
      )}
      {product === "p3" && <div>{renderQntyP3()}</div>}
      <div>{showCalculate && renderCalculate()}</div>
    </div>
  );
};

function scrollBottom() {
  setTimeout(
    () =>
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" }),
    1
  );
}

function calculateTotal({ p, qty, join, qtyType, x, y, z }) {
  // eslint-disable-next-line prefer-rest-params
  console.log("ARGS", arguments[0]);
  let kg = 0;
  if (p !== "p3") {
    const ftype = `${join}_${p}_${qtyType}`;
    switch (ftype) {
      case "1_p1_mp":
        kg =
          ((x * y * 10 + y * z * 10) / 1000000) *
          1.8 *
          (1000000 / (x * z)) *
          qty *
          0.84;
        return {
          kg,
          bags: kg / 25,
        };
      case "1_p1_mc":
        kg =
          ((x * y * 10 + y * z * 10) / 1000000) *
          1.8 *
          (1000000 / (x * z)) *
          (1000 / y) *
          qty *
          0.84;
        return {
          kg,
          bags: kg / 25,
        };
      case "1_p2_mp":
        kg =
          ((x * y * 3 + y * z * 3) / 1000000) *
          2 *
          (1000000 / (x * z)) *
          qty *
          0.8;
        return {
          kg,
          bags: kg / 25,
        };
      case "1_p2_mc":
        kg =
          ((x * y * 3 + y * z * 3) / 1000000) *
          2 *
          (1000000 / (x * z)) *
          (1000 / y) *
          qty *
          0.8;
        return {
          kg,
          bags: kg / 25,
        };
      case "2_p1_mp":
        kg = ((x * y * 10) / 1000000) * 1.8 * (1000000 / (x * z)) * qty * 0.84;
        return {
          kg,
          bags: kg / 25,
        };
      case "2_p1_mc":
        kg =
          ((x * y * 10) / 1000000) *
          1.8 *
          (1000000 / (x * z)) *
          (1000 / y) *
          qty *
          0.84;
        return {
          kg,
          bags: kg / 25,
        };
      case "2_p2_mp":
        kg =
          ((x * y * 3 + y * z * 3) / 1000000) *
          2 *
          (1000000 / (x * z)) *
          qty *
          0.8;
        return {
          kg,
          bags: kg / 25,
        };
      case "2_p2_mc":
        kg =
          ((x * y * 3) / 1000000) *
          2 *
          (1000000 / (x * z)) *
          (1000 / y) *
          qty *
          0.8;
        return {
          kg,
          bags: kg / 25,
        };
    }
  } else {
    kg = qty * 1.4 * 10;
    return {
      kg,
      bags: kg / 25,
    };
  }
}

export default App;
